export default __webpack_public_path__ + "static/media/en.8f47d6e6.gif";